"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TertiaryButton = void 0;

var _react = _interopRequireDefault(require("react"));

var _dedupe = _interopRequireDefault(require("classnames/dedupe"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ButtonWrapper = require("./ButtonWrapper");

var _btnPropTypes = require("./btnPropTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* the Tertiary button which can contain an icon element
 * to be used within another component that will supply page layout
 */
var TertiaryButton = function TertiaryButton(_ref) {
  var atts = _ref.atts,
      ariaLabel = _ref.ariaLabel,
      cashbotName = _ref.cashbotName,
      isSmall = _ref.isSmall,
      isLeftAligned = _ref.isLeftAligned,
      isInline = _ref.isInline,
      onClick = _ref.onClick,
      doFocus = _ref.doFocus,
      icon = _ref.icon,
      btnText = _ref.btnText,
      ariaDescribedBy = _ref.ariaDescribedBy,
      errorDisplayed = _ref.errorDisplayed;
  var buttonProps = {
    atts: atts,
    cashbotName: cashbotName,
    ariaLabel: ariaLabel,
    cssClass: (0, _dedupe.default)('btn', 'btn_tertiary', {
      'btn--small': isSmall
    }, {
      'btn_tertiary_inline': isInline
    }),
    onClick: onClick,
    doFocus: doFocus,
    icon: icon,
    btnText: btnText,
    ariaDescribedBy: ariaDescribedBy,
    errorDisplayed: errorDisplayed
  };
  return _react.default.createElement(_ButtonWrapper.ButtonWrapper, buttonProps, !isLeftAligned && _react.default.createElement("span", null, btnText), icon && _react.default.createElement("span", {
    className: "btn__icon"
  }, icon), isLeftAligned && _react.default.createElement("span", null, btnText));
};

exports.TertiaryButton = TertiaryButton;
TertiaryButton.defaultProps = _objectSpread({}, _btnPropTypes.tertiaryBtnDefaults, {
  showLoading: false,
  errorDisplayed: false
});
TertiaryButton.propTypes = _objectSpread({}, _btnPropTypes.tertiaryBtnPropTypes, {
  showLoading: _propTypes.default.bool,
  errorDisplayed: _propTypes.default.bool
});